<div class="energy-reads-card">
    <div class="er-header">
        <div class="view-toggle">
            <button type="button" [class.active]="viewMode === 'graph'" (click)="setViewMode('graph')">
                <i class="bi bi-bar-chart-line"></i> {{ "GRAPH" | translate }}
            </button>
            <button type="button" [class.active]="viewMode === 'table'" (click)="setViewMode('table')">
                <i class="bi bi-table"></i> {{ "TABLE" | translate }}
            </button>
        </div>
        <div class="range-controls">
        <div class="range-tabs">
            <button type="button" *ngFor="let r of ranges" [class.active]="activeRange === r"
                (click)="selectRange(r)">{{ r }}</button>
        </div>
            @if (viewMode === 'graph') {
            <button type="button" class="reset-zoom-btn" (click)="resetZoom()" [title]="'RESET_ZOOM' | translate">
                <i class="bi bi-zoom-out"></i>
            </button>
            }
        </div>
    </div>

    @if (viewMode === 'graph') {
    <div class="chart-frame">
        @if (readings.length > 0) {
        <canvas baseChart [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins" type="line"></canvas>
        } @else {
        <div class="chart-empty-state">
            <i class="bi bi-bar-chart-line"></i>
            <span>{{ "NO_READS_FOR_RANGE" | translate }}</span>
        </div>
        }
    </div>

    <div class="chart-legend">
        <div class="legend-category" *ngFor="let cat of legendCategories">
            <label class="legend-category-header">
                @if (readings.length > 0) {
                <input type="checkbox" [checked]="isCategoryVisible(cat)" (change)="toggleCategory(cat)" />
                }
                @if (cat.indices.length === 1) {
                <span class="dot" [style.background-color]="seriesConfig[cat.indices[0]].color"></span>
                }
                <span class="legend-category-title">{{ cat.titleKey | translate }}</span>
            </label>
            @if (cat.indices.length > 1) {
            <div class="legend-category-items">
                <label class="legend-item" *ngFor="let i of cat.indices">
                    @if (readings.length > 0) {
                    <input type="checkbox" [checked]="seriesVisible[i]" (change)="toggleSeries(i)" />
                    }
                    <span class="dot" [style.background-color]="seriesConfig[i].color"></span>
                    {{ phaseLabel(seriesConfig[i].key) }}
                </label>
            </div>
            }
        </div>
    </div>
    }

    @if (viewMode === 'table') {
    <div #tableContainer class="table-container">
        <table>
            <thead>
                <tr>
                    <td class="custom-width">{{ "TIME" | translate | uppercase }}</td>
                    <td colspan="3">{{ "INSTANTANEOUSVOLTAGE" | translate }}</td>
                    <td colspan="3">{{ "AVERAGE_VOLTAGE" | translate | uppercase }}</td>
                    <td colspan="3">{{ "INSTANTANEOUSCURRENT" | translate }}</td>
                    <td colspan="3">{{ "AVERAGE_CURRENT" | translate | uppercase }}</td>
                    <td colspan="3" class="custom-width">{{ "POWERFACTOR" | translate }}</td>
                    <td class="custom-width">{{ "FREQUENCY" | translate }}</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of tableRows">
                    <td class="table-name-number">
                        <span>{{ row.meterTime | date: 'dd MMM yyyy, h:mm a' }}</span>
                    </td>

                    <!-- Instantaneous Voltage -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Line 1" src="assets/load-profile/l1.svg" />
                            <span [attr.title]="row.instantaneousVoltageL1 + ' V'">
                                {{ row.instantaneousVoltageL1 == null ? 'N/A' : (row.instantaneousVoltageL1 | number: '1.0-4') + ' V' }}
                            </span>
                        </div>
                    </td>
                    <td class="mid-cell">
                        <div class="cell">
                            <img alt="Line 2" src="assets/load-profile/l2.svg" />
                            <span [attr.title]="row.instantaneousVoltageL2 + ' V'">
                                {{ row.instantaneousVoltageL2 == null ? 'N/A' : (row.instantaneousVoltageL2 | number: '1.0-4') + ' V' }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Line 3" src="assets/load-profile/l3.svg" />
                            <span [attr.title]="row.instantaneousVoltageL3 + ' V'">
                                {{ row.instantaneousVoltageL3 == null ? 'N/A' : (row.instantaneousVoltageL3 | number: '1.0-4') + ' V' }}
                            </span>
                        </div>
                    </td>

                    <!-- Average Voltage -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Line 1" src="assets/load-profile/l1.svg" />
                            <span [attr.title]="row.averageVoltageL1 + ' V'">
                                {{ row.averageVoltageL1 == null ? 'N/A' : (row.averageVoltageL1 | number: '1.0-4') + ' V' }}
                            </span>
                        </div>
                    </td>
                    <td class="mid-cell">
                        <div class="cell">
                            <img alt="Line 2" src="assets/load-profile/l2.svg" />
                            <span [attr.title]="row.averageVoltageL2 + ' V'">
                                {{ row.averageVoltageL2 == null ? 'N/A' : (row.averageVoltageL2 | number: '1.0-4') + ' V' }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Line 3" src="assets/load-profile/l3.svg" />
                            <span [attr.title]="row.averageVoltageL3 + ' V'">
                                {{ row.averageVoltageL3 == null ? 'N/A' : (row.averageVoltageL3 | number: '1.0-4') + ' V' }}
                            </span>
                        </div>
                    </td>

                    <!-- Instantaneous Current -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Line 1" src="assets/load-profile/l1.svg" />
                            <span [attr.title]="row.instantaneousCurrentL1 + ' A'">
                                {{ row.instantaneousCurrentL1 == null ? 'N/A' : (row.instantaneousCurrentL1 | number: '1.0-4') + ' A' }}
                            </span>
                        </div>
                    </td>
                    <td class="mid-cell">
                        <div class="cell">
                            <img alt="Line 2" src="assets/load-profile/l2.svg" />
                            <span [attr.title]="row.instantaneousCurrentL2 + ' A'">
                                {{ row.instantaneousCurrentL2 == null ? 'N/A' : (row.instantaneousCurrentL2 | number: '1.0-4') + ' A' }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Line 3" src="assets/load-profile/l3.svg" />
                            <span [attr.title]="row.instantaneousCurrentL3 + ' A'">
                                {{ row.instantaneousCurrentL3 == null ? 'N/A' : (row.instantaneousCurrentL3 | number: '1.0-4') + ' A' }}
                            </span>
                        </div>
                    </td>

                    <!-- Average Current -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Line 1" src="assets/load-profile/l1.svg" />
                            <span [attr.title]="row.averageCurrentL1 + ' A'">
                                {{ row.averageCurrentL1 == null ? 'N/A' : (row.averageCurrentL1 | number: '1.0-4') + ' A' }}
                            </span>
                        </div>
                    </td>
                    <td class="mid-cell">
                        <div class="cell">
                            <img alt="Line 2" src="assets/load-profile/l2.svg" />
                            <span [attr.title]="row.averageCurrentL2 + ' A'">
                                {{ row.averageCurrentL2 == null ? 'N/A' : (row.averageCurrentL2 | number: '1.0-4') + ' A' }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Line 3" src="assets/load-profile/l3.svg" />
                            <span [attr.title]="row.averageCurrentL3 + ' A'">
                                {{ row.averageCurrentL3 == null ? 'N/A' : (row.averageCurrentL3 | number: '1.0-4') + ' A' }}
                            </span>
                        </div>
                    </td>

                    <!-- Power Factor -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Line 1" src="assets/load-profile/l1.svg" />
                            <span [attr.title]="row.instantaneousPowerFactorL1">{{ row.instantaneousPowerFactorL1 == null ? 'N/A' : (row.instantaneousPowerFactorL1 | number: '1.0-4') }}</span>
                        </div>
                    </td>
                    <td class="mid-cell">
                        <div class="cell">
                            <img alt="Line 2" src="assets/load-profile/l2.svg" />
                            <span [attr.title]="row.instantaneousPowerFactorL2">{{ row.instantaneousPowerFactorL2 == null ? 'N/A' : (row.instantaneousPowerFactorL2 | number: '1.0-4') }}</span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Line 3" src="assets/load-profile/l3.svg" />
                            <span [attr.title]="row.instantaneousPowerFactorL3">{{ row.instantaneousPowerFactorL3 == null ? 'N/A' : (row.instantaneousPowerFactorL3 | number: '1.0-4') }}</span>
                        </div>
                    </td>

                    <!-- Frequency -->
                    <td>
                        <span [attr.title]="row.instantaneousFrequency + ' Hz'">
                            {{ row.instantaneousFrequency == null ? 'N/A' : (row.instantaneousFrequency | number: '1.0-4') + ' Hz' }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="tableLastPageSize" [numberOfDevices]="tableRowCount"
            [pageSize]="tablePageSize" [currentPage]="tableCurrentPage"
            (pageChange)="loadTableRows($event)"></app-pagination>
    </div>
    }
</div>
